import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        trainingForm: '=',
        trainingIndex: '=',
        isDisabled: '=',
        form: '=',
        context: '=',
        canManageCourse: '=',
        materialErrors: '=',
        save: '&'
    },
    template: `
    <ul class="tabs01">
        <li ng-repeat="lang in vm.getSortedLanguages()">
            <span
                ng-repeat="material in vm.trainingForm.materials"
                ng-class="{ active: vm.activeLang==material.lang, enabled: material.isEnabled==true }"
                ng-if="material.lang === lang"
            >
                <a ng-click="vm.changeLang(material.lang)">{{ material.lang }}</a>
            </span>
        </li>
    </ul>
    <div ng-repeat="(index, material) in vm.trainingForm.materials">
        <form-row error="vm.getError(index)">
            <form-row-error></form-row-error>
        </form-row>
    </div>
    <div ng-repeat="(materialIndex, material) in vm.trainingForm.materials">
        <div ng-if="material.lang===vm.activeLang">
            <div class="simple-materials">
                <div class="simple-materials-main">
                    <div class="form condenced">
                        <label class="switch01 visible-label">
                            <input type="checkbox" ng-model="material.isEnabled">
                            <span class="ng-binding">{{ material.lang }} {{ 'course.materialSource.translation enabled' | translate }}</span>
                        </label>

                        <div style="margin-top:14px" ng-repeat="(index, chapter) in material.chapters" class="block04" ng-class="{'open': chapter.isOpened === true}">
                            <courses-authoring-tool-chapter
                                chapter-form="chapter"
                                form="vm.form"
                                context="vm.context"
                                training-index="vm.trainingIndex"
                                material-index="materialIndex"
                                material="material"
                                chapter-index="index"
                                delete="vm.deleteChapter(index, material.lang)"
                                save="vm.save()"
                                is-disabled="vm.isDisabled"
                            ></courses-authoring-tool-chapter>
                        </div>
                        <ul class="actions01 nomargin">
                            <li><a ng-click="vm.addChapter()" class="btn add small">{{ 'course.materialSource.Add chapter' | translate }}</a></li>
                            <li class="primary">
                                <a ng-click="vm.preview(material)" class="btn secondary small">
                                    <span>{{ 'course.materialSource.Preview module' | translate }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    `
})
export default class {
    constructor (TokenService, lodash, $translate, ModalService, $scope, $rootScope, $state,
        MaterialSubmissionResource, CourseVersionTrainingFormMaterialService
    ) {
        this.TokenService = TokenService;
        this.$translate = $translate;
        this.lodash = lodash;
        this.ModalService = ModalService;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.MaterialSubmissionResource = MaterialSubmissionResource;
        this.MaterialService = CourseVersionTrainingFormMaterialService;

        this.defaultLanguage = this.TokenService.getCompanyLanguage();
        this.companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();
        this.activeLangLocalStorageKey = `authoringTool.activeLang.${this.form.model.courseId}${this.form.model.name}.${this.trainingIndex}`;

        this.trainingForm.materials = this.MaterialService.transformMaterialsFromApi(
            this.trainingForm.materials
        );
        this.initChapters();

        const activeLang = localStorage.getItem(this.activeLangLocalStorageKey);
        this.activeLang = activeLang === null ? this.defaultLanguage : activeLang;
    }

    changeLang (lang) {
        this.activeLang = lang;
        localStorage.setItem(this.activeLangLocalStorageKey, lang);
    }

    getError (materialIndex) {
        if (this.form.errors.courseTrainings !== undefined
            && this.form.errors.courseTrainings[this.trainingIndex] !== undefined
            && this.form.errors.courseTrainings[this.trainingIndex].materials[materialIndex] !== undefined) {
            return this.flatten(this.form.errors.courseTrainings[this.trainingIndex].materials[materialIndex]);
        }
        return null;
    }

    flatten (data) {
        if (typeof data === 'string') {
            return data;
        }
        const flattenItem = Object.values(data)[0];
        if (typeof flattenItem !== 'string') {
            return this.flatten(flattenItem);
        }
        return flattenItem;
    }

    initChapters () {
        if (!this.trainingForm.id) {
            this.trainingForm.materials = [];
        }

        // Use a single shared hash for the initial default chapter across all languages
        // so the structure stays language-neutral from the start
        const defaultChapterHash = this.makeHash();

        this.lodash.forEach(this.companySupportedLanguages, lang => {
            const material = this.lodash.find(this.trainingForm.materials, existingMaterial => existingMaterial.lang === lang);
            if (material === undefined) {
                let isEnabled = false;
                if (lang === this.defaultLanguage) {
                    isEnabled = true;
                }
                this.trainingForm.materials.push(
                    {
                        lang,
                        isEnabled,
                        chapters: [
                            {
                                name: null,
                                content: null,
                                isOpened: true,
                                hash: defaultChapterHash
                            }
                        ]
                    },
                );
            }
            else {
                if (!material.chapters.length) {
                    material.chapters.push(
                        {
                            name: null,
                            content: null,
                            isOpened: true,
                            hash: defaultChapterHash
                        }
                    );
                }
            }
        });
    }

    makeHash () {
        const length = 64;
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    getSortedLanguages () {
        const languages = [];
        languages.push(this.defaultLanguage);
        this.lodash.forEach(this.companySupportedLanguages, lang => {
            if (lang !== this.defaultLanguage) {
                languages.push(lang);
            }
        });
        return languages;
    }

    addChapter () {
        // close previous chapters
        this.lodash.forEach(this.trainingForm.materials, (material) => {
            this.lodash.forEach(material.chapters, (chapter) => {
                chapter.isOpened = false;
            });
        });

        // add new chapter to all languages with the same hash
        const hash = this.makeHash();
        this.lodash.forEach(this.trainingForm.materials, (material) => {
            material.chapters.push({
                name: null,
                content: null,
                isOpened: material.lang === this.activeLang,
                isVisible: true,
                hash
            });
        });
    }

    deleteChapter (index, lang) {
        return this.ModalService.confirm(
            this.$translate.instant(
                'materials.Are you sure you wish to delete the chapter? It will be removed from all languages.'
            ), 'medium')
            .then(() => {
                const activeMaterial = this.lodash.find(
                    this.trainingForm.materials, { lang }
                );
                if (!activeMaterial) {
                    return;
                }
                const chapterHash = activeMaterial.chapters[index]
                    ? activeMaterial.chapters[index].hash
                    : null;

                this.lodash.forEach(this.trainingForm.materials, (material) => {
                    const chapterIndex = chapterHash
                        ? material.chapters.findIndex(c => c.hash === chapterHash)
                        : index;

                    if (chapterIndex < 0) {
                        return;
                    }

                    if (material.chapters.length > 1) {
                        material.chapters.splice(chapterIndex, 1);
                        if (material.lang === lang) {
                            const previous = material.chapters[chapterIndex - 1];
                            if (previous !== undefined) {
                                previous.isOpened = true;
                            }
                        }
                    }
                    else {
                        material.chapters[0].name = '';
                        material.chapters[0].content = '';
                        this.$rootScope.$broadcast(
                            'tinymce:removeContent',
                            { hash: material.chapters[0].hash }
                        );
                    }
                });
            })
        ;
    }

    generateSubmission (material) {
        this.MaterialSubmissionResource.save({
            name: 'Test submission name',
            email: 'example@opus.ee',
            materialId: material.id,
            userId: this.TokenService.getUser().id
        }).$promise.then((data) => {
            this.previewInIframe(data.guid);
        });
    }

    preview (material) {
        this.previewInModal(material);
        // this.generateSubmission(material);
        // if (material.id) {
        //    this.generateSubmission(material);
        // }
        // else {
        //    this.previewInModal(material);
        // }
    }

    previewInIframe (guid) {
        return this.ModalService.open({
            size: 'xlarge',
            template: `
                <modals-courses-version-training-material-preview-iframe
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    guid="vm.guid"
                />`,
            controller ($uibModalInstance) {
                this.guid = guid;
                this.$uibModalInstance = $uibModalInstance;
            }
        });
    }

    previewInModal (material) {
        const { trainingForm } = this;
        return this.ModalService.open({
            size: 'full',
            template: `
                <modals-courses-version-training-material-preview
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    material="vm.material"
                    training-name="vm.trainingName"
                    company="vm.company"
                />`,
            resolve: {
                company (CompanyResource, TokenService) {
                    return CompanyResource.publicView({ id: TokenService.getCompanyId() }).$promise;
                }
            },
            controller ($uibModalInstance, TokenService, company) {
                const defaultLanguage = TokenService.getCompanyLanguage();
                this.material = material;
                this.trainingName = trainingForm.courseTrainingI18ns[defaultLanguage].name;
                this.company = company;
                this.$uibModalInstance = $uibModalInstance;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/authoringTool/content/index.js